import type { TranslationKeysProStudio } from '@pypestream/translations';

import type { UnconnectedStatus } from '../../utils';

// User-facing strings of the "not connected to a Live Agent Platform" experience
// (PSTUDIO-4344) are i18n keys in `pro-studio/common`, under
// `liveAgentNotConnected`. Channel Settings, the Design panel and the Live Agent
// Platforms page read the status line from here, so the wording cannot differ.
export const UNCONNECTED_I18N_KEYS = {
  title: 'pro-studio/common:liveAgentNotConnected.title',
  description: 'pro-studio/common:liveAgentNotConnected.description',
  colChannel: 'pro-studio/common:liveAgentNotConnected.colChannel',
  colSolution: 'pro-studio/common:liveAgentNotConnected.colSolution',
  colStatus: 'pro-studio/common:liveAgentNotConnected.colStatus',
  colConnectTo: 'pro-studio/common:liveAgentNotConnected.colConnectTo',
  statusNone: 'pro-studio/common:liveAgentNotConnected.statusNone',
  statusAgentPro: 'pro-studio/common:liveAgentNotConnected.statusAgentPro',
  choosePlatform: 'pro-studio/common:liveAgentNotConnected.choosePlatform',
  pickerLabel: 'pro-studio/common:liveAgentNotConnected.pickerLabel',
  save: 'pro-studio/common:liveAgentNotConnected.save',
  saving: 'pro-studio/common:liveAgentNotConnected.saving',
  connected: 'pro-studio/common:liveAgentNotConnected.connected',
  saveError: 'pro-studio/common:liveAgentNotConnected.saveError',
  allConnectedTitle:
    'pro-studio/common:liveAgentNotConnected.allConnectedTitle',
  allConnectedBody: 'pro-studio/common:liveAgentNotConnected.allConnectedBody',
} as const satisfies Record<
  string,
  Extract<
    TranslationKeysProStudio,
    `pro-studio/common:liveAgentNotConnected.${string}`
  >
>;

export const unconnectedStatusKey = (status: UnconnectedStatus) =>
  status === 'agentpro'
    ? UNCONNECTED_I18N_KEYS.statusAgentPro
    : UNCONNECTED_I18N_KEYS.statusNone;
